var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChatLayout',{attrs:{"title":"Asistente resultados evaluación","waitingMessage":_vm.waitingMessage,"historyMessages":_vm.historyMessages},on:{"keyup":_vm.handleInput},model:{value:(_vm.userMessage),callback:function ($$v) {_vm.userMessage=$$v},expression:"userMessage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }